// extracted by mini-css-extract-plugin
export default {"quantity_wrapper":"CX","increment":"EX","decrement":"FX","product":"GX","product_info":"HX","text":"IX","modify_btn":"JX","controls":"KX","price":"LX","deliveredOnce":"MX"};
    if(module.hot) {
      // 1713809679437
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  